import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import Multiselect from './components/Multiselect'
import { useAgencyInfo } from 'context/agency'
import Editor from 'components/editor'

const CreateModal = ({ teamTags, handleRefresh }) => {
  const [agency] = useAgencyInfo()
  const [description, setDescription] = useState('')

  const uploadImage = useUploadImage()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const [selectedRoles, setSelectedRoles] = useState([])
  const [tags, setTags] = useState([])
  const [liveOnApp, setLiveOnApp] = useState('no') // Changed to string with default 'no'

  const [user] = useUserInfo()

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      const value = e.target.value.trim()
      if (value && !tags.includes(value)) {
        setTags([...tags, value])
        e.target.value = ''
      }
    }
  }

  const team_tags = teamTags?.map((item) => {
    return {
      label: item?.name,
      value: item?.name?.toLowerCase().replace(/\s+/g, '-'),
    }
  })

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 440,
    maxHeight: '90vh',
    bgcolor: 'background.paper',
    borderRadius: '10px',
    boxShadow: 24,
    p: 4,
    overflowY: 'auto',
  }

  const permissions = [
    { label: 'Agent', value: 'agent' },
    { label: 'Developer', value: 'developer' },
    { label: 'Manager', value: 'manager' },
    { label: 'Support', value: 'support' },
    { label: 'Superadmin', value: 'superadmin' },
    { label: 'Graphics', value: 'graphics' },
    { label: 'Client Handling', value: 'client_handling' },
    { label: 'Social Media', value: 'social' },
    { label: 'Onboarding Admin', value: 'onboarding_admin' },
    { label: 'Client', value: 'client' },
  ]
  const optionn = [

    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },

  ]
  const handlemodal = () => setOpenAddProduct(true)
  const closeAddProduct = () => setOpenAddProduct(false)

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)

    const handleSubmit = async (e) => {
      e.preventDefault()
      const roles = JSON.parse(e.target.roles.value)
      let image_response;

      if (e.target?.image?.files?.[0]) {
        image_response = await uploadImage({
          file: e.target?.image?.files?.[0],
          desiredPath: `app/logo/image`,
        });
      }


      const data = {
        username: e.target.username.value,
        email: e.target.email.value,
        password: e.target.password.value,
        roles: roles?.map((item) => item.value),
        type: 'super_admin_team',
        agency_id: agency._id,
        tags: e.target.tags ? JSON.parse(e.target.tags.value) : [],
        liveOnApp: liveOnApp, // Now using the dropdown value
        description: description,
        calender: e.target.calender.value,
        image: image_response?.response?.data || "",
      }
      const payload = { data }

      const { response } = await AppService.auth.CreateTeam({ payload })
      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }
    const handleRoleChange = (selected) => {
      setSelectedRoles(selected.map((item) => item.value))
    }

    return (
      <MDModal open={open} onClose={onClose} width={440}>
        <MDBox sx={style}>
          <MDTypography variant="h5" mb={2}>
            Create Team User
          </MDTypography>
          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={{
              maxHeight: 'calc(90vh - 100px)',
              overflowY: 'auto',
              pr: 1,
              '&::-webkit-scrollbar': {
                width: '6px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '10px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '10px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
              },
            }}
          >
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Name
            </MDTypography>
            <MDInput label="Name" placeholder="Name" name="username" fullWidth />

            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Email
            </MDTypography>
            <MDInput label="Email" placeholder="Email" name="email" fullWidth />

            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Password
            </MDTypography>
            <MDInput
              label="Password"
              type="password"
              placeholder="Password"
              name="password"
              fullWidth
            />

            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Role
            </MDTypography>
            <Multiselect
              data={permissions}
              edit_data={[]}
              isMulti={true}
              name="roles"
              onChange={handleRoleChange}
            />

            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Tags
            </MDTypography>
            <Multiselect
              data={team_tags}
              edit_data={[]}
              isMulti={true}
              name="tags"
              onChange={handleRoleChange}
            />
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Live on App UI
            </MDTypography>
            <Multiselect
              data={optionn}
              edit_data={[]}
              isMulti={false}
              name="liveOnApp"
              onChange={handleRoleChange}
            />

            {/* <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              
            </MDTypography>
            <FormControl fullWidth>
              <Select
                value={liveOnApp}
                onChange={(e) => setLiveOnApp(e.target.value)}
                name="liveOnApp"
              >
                <MenuItem value="yes">Yes</MenuItem>
                <MenuItem value="no">No</MenuItem>
              </Select>
            </FormControl> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>


            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Calendar
            </MDTypography>
            <MDInput label="Calendar" placeholder="Calendar URL" name="calender" fullWidth />
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }} style={{ marginTop: "3rem" }} fullWidth>
                Upload Profile Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end" mt={3}>
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mb: 1 }}
                onClick={onClose}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handlemodal}>
        Create
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal